import * as React from 'react';
import { useTheme } from '@mui/material/styles';
import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';
import Typography from '@mui/material/Typography';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
  Tooltip,
  Legend,
} from 'recharts';
import { Project } from '../../types';

interface ProjectStatusChartProps {
  projects: Project[];
}

export default function ProjectStatusChart({ projects }: ProjectStatusChartProps) {
  const theme = useTheme();

  const statusData = [
    { 
      name: 'Active', 
      value: projects.filter(p => p.status === 'Active' || p.status === 'In Progress').length,
      color: theme.palette.primary.main 
    },
    { 
      name: 'Completed', 
      value: projects.filter(p => p.status === 'Completed').length,
      color: theme.palette.success.main 
    },
    { 
      name: 'On Hold', 
      value: projects.filter(p => p.status === 'On Hold').length,
      color: theme.palette.warning.main 
    },
  ].filter(item => item.value > 0);

  return (
    <Card variant="outlined" sx={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
      <CardContent sx={{ flexGrow: 1, minHeight: 0 }}>
        <Typography component="h2" variant="subtitle2" gutterBottom>
          Project Distribution
        </Typography>
        <ResponsiveContainer width="100%" height={250}>
          <PieChart>
            <Pie
              data={statusData}
              cx="50%"
              cy="50%"
              innerRadius={60}
              outerRadius={80}
              paddingAngle={5}
              dataKey="value"
            >
              {statusData.map((entry, index) => (
                <Cell key={`cell-${index}`} fill={entry.color} />
              ))}
            </Pie>
            <Tooltip 
              contentStyle={{ 
                backgroundColor: theme.palette.background.paper,
                border: `1px solid ${theme.palette.divider}`,
                borderRadius: 8
              }}
            />
            <Legend verticalAlign="bottom" height={36}/>
          </PieChart>
        </ResponsiveContainer>
      </CardContent>
    </Card>
  );
}
